













































import { Component, Vue } from 'vue-property-decorator'
import Card from '@/components/Card.vue'
import ResultCard from '@/components/ResultCard.vue'
import axios from 'axios'
import Alert from "@/components/Alert.vue";

@Component({
  components: {
    Card,
    ResultCard,
    Alert
  },
})
export default class Test extends Vue {
  cathegories = []
  category = 1
  nor = 0
  start = 0
  end = 2
  activeResult: any = null
  id?: number | null = null
  url = 'https://afq-t32f44ncfa-ey.a.run.app/items/'
  results: any[] = []
  message = ''
  $router: any
  async mounted() {
    this.cathegories = (await axios.get(this.url + 'category')).data.data
    await this.reloadCard()
  }
  async reloadCard() {
    const request =
      this.url +
      `result?fields=*,type.*&offset=${this.start}&limit=${this.end}&filter={"category": {"_eq": ${this.category}}}`
    let results = (await axios.get(request)).data.data
    if (results[0]) {
      this.results = results
      this.results = results.map((result: any) => {
        result.actions = [];
        result.weight = result.type.weight + result.isFavorite * 1000;
        return result;
      });
    } else {
      this.results = []
    }
    this.nor = (
      await axios.get(
        this.url +
          `result?fields=*&limit=0&meta=filter_count&filter={"category": {"_eq": ${this.category}}}`,
      )
    ).data.meta.filter_count
  }
  async reload() {
    this.message = ''
    await this.reloadCard()
  }
}
